import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-xl px-6 py-32 text-center">
      <XCircle className="mx-auto h-16 w-16 text-stone-400" />
      <h1 className="mt-4 font-display text-3xl font-bold text-stone-900">Payment cancelled</h1>
      <p className="mt-3 text-stone-600">Your cart is still saved. You can complete your order whenever you're ready.</p>
      <Link to="/checkout" className="mt-6 inline-block rounded-full bg-orange-700 px-6 py-3 font-bold text-white hover:bg-orange-800">Back to Checkout</Link>
    </div>
  );
}
